import clsx from 'clsx'
import { EventType } from '../../hooks/useCurrentEvent'
import { ThemeName } from '../../constants/theme'

export interface GetLottoGameCardSurfaceClassesParams {
  isGameOpen: boolean
  event: EventType | null
}

export const getLottoGameCardSurfaceClasses = ({
  isGameOpen,
  event,
}: GetLottoGameCardSurfaceClassesParams): string => {
  return clsx(
    'rounded-xl shadow-lg overflow-visible h-full flex flex-col border border-[var(--lotto-card-border)] relative',
    isGameOpen
      ? 'bg-[var(--card-bg)]'
      : 'bg-[var(--card-disabled-bg)] lotto-card-disabled',
    event === EventType.CHRISTMAS && isGameOpen && 'christmas-card-active',
    event === EventType.CHINESE_NEW_YEAR && isGameOpen && 'cny-card-active',
    event === EventType.SAKURA && isGameOpen && 'sakura-card-active',
    event === EventType.HALLOWEEN && isGameOpen && 'halloween-card-active',
    event === EventType.LOY_KRATHONG &&
      isGameOpen &&
      'loy-krathong-card-active',
  )
}

export interface LottoGameCardDecoration {
  key: string
  src: string
  alt: string
  className: string
}

export interface GetLottoGameCardDecorationsParams {
  isGameOpen: boolean
  event: EventType | null
  themeName: ThemeName
  ribbonImage?: string | null
  abstractBorderImage?: string | null
  cardLanternImage?: string | null
  cardFlagBannerImage?: string | null
}

export const getLottoGameCardDecorations = ({
  isGameOpen,
  event,
  themeName,
  ribbonImage,
  abstractBorderImage,
  cardLanternImage,
  cardFlagBannerImage,
}: GetLottoGameCardDecorationsParams): LottoGameCardDecoration[] => {
  if (!isGameOpen) return []

  const decorations: LottoGameCardDecoration[] = []

  if (event === EventType.CHRISTMAS && ribbonImage) {
    decorations.push({
      key: 'christmas-ribbon',
      src: ribbonImage,
      alt: 'Christmas Ribbon',
      className: 'christmas-ribbon',
    })
  }

  if (
    event === EventType.CHINESE_NEW_YEAR &&
    abstractBorderImage &&
    themeName === ThemeName.GOLD
  ) {
    decorations.push({
      key: 'cny-border',
      src: abstractBorderImage,
      alt: 'Chinese New Year Border',
      className: 'cny-border',
    })
  }

  if (
    event === EventType.CHINESE_NEW_YEAR &&
    cardLanternImage &&
    themeName === ThemeName.BLUE
  ) {
    decorations.push({
      key: 'cny-card-lantern',
      src: cardLanternImage,
      alt: 'Chinese New Year Lantern',
      className: 'cny-card-lantern',
    })
  }

  if (
    event === EventType.SAKURA &&
    cardLanternImage &&
    themeName === ThemeName.BLUE
  ) {
    decorations.push({
      key: 'sakura-card-lantern',
      src: cardLanternImage,
      alt: 'Sakura Lantern',
      className: 'sakura-card-lantern',
    })
  }

  if (
    event === EventType.SONGKRAN &&
    cardFlagBannerImage &&
    themeName === ThemeName.GOLD
  ) {
    decorations.push({
      key: 'songkran-card-flag',
      src: cardFlagBannerImage,
      alt: 'Songkran Flag Banner',
      className: 'songkran-card-flag',
    })
  }

  if (event === EventType.LOY_KRATHONG && cardLanternImage) {
    decorations.push({
      key: 'loy-krathong-card-decor',
      src: cardLanternImage,
      alt: 'Loy Krathong Decoration',
      className: 'loy-krathong-card-decor',
    })
  }

  return decorations
}
